import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import './styles.scss';
import Button from '@material-ui/core/Button';
import Test from './Test';
import data1 from './data/part1-test.json';
import data2 from './data/part2-test.json';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import axios from 'axios';

const levelThreshold = 5;
const baseUrl = 'https://briantracyenglish.pl/test-poziomujacy';
// const baseUrl = 'http://localhost:3000';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#013156'
    },
    secondary: {
      main: '#bb0d80',
    },
  },
});

const useStyles = makeStyles(theme => ({
  pageWrap: {
    width: 1200,
    maxWidth: '100%',
    margin: 'auto',
    padding: theme.spacing(2, 0),
  },
  container: {
    padding: theme.spacing(2),
    width: 800,
    maxWidth: '100%',
    margin: '0 auto',
    border: '4px solid #0fa9de',
    borderRadius: 10,
  },
  introButtons: {
    width: 300,
    maxWidth: '100%',
    margin: '30px auto',
    '& button': {
      width: '100%',
      marginBottom: 10,
    },
  },
  wrap: {
    '& h3': {
      textAlign: 'center',
    },
  },
  text: {
    marginBottom: theme.spacing(1),
    width: 300,
    textAlign: 'center',
  },
}));

const intro = [
  `Celem testu jak najdokładniejsze określenie Państwa poziomu językowego. Aby test był miarodajny,
   a jego wynik odzwierciedlał rzeczywistą znajomość języka angielskiego powinien być rozwiązany
   uczciwie. Na każde pytanie tylko 1 odpowiedź jest prawidłowa. Jeśli nie znasz odpowiedzi
   lub nie jesteś jej pewien POMIŃ dane pytanie i PRZEJDŹ DO NASTĘPNEGO. Wybór odpowiedzi na 'chybił
   trafił' spowoduje zafałszowanie wyniku testu, co w rezultacie może skutkować błędnym wynikiem.`,
   `Jeśli jesteś początkujący, proszę wypełnić tylko I część. Jeśli I część nie sprawiła Państwu
   trudności, proszę o wypełnienie części II.`
];

const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function App() {
  const classes = useStyles();
  const [view, setView] = useState('intro');
  const [part1Points, setPart1Points] = useState(0);
  const [part2Points, setPart2Points] = useState(0);
  const [part1Finished, setPart1Finished] = useState(false);
  const [part2Finished, setPart2Finished] = useState(false);
  const [finish, setFinish] = useState(false);
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(false);
  const [emailApprove, setEmailApprove] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const points = part1Points + part2Points;

  useEffect(() => {
    if (!finish) return;
    finishTest();
    // eslint-disable-next-line
  }, [finish]);

  const finishPart1 = (points) => {
    setPart1Points(points);
    setPart1Finished(true);
    setView('intro');
  }

  const finishPart2 = (points) => {
    setPart2Points(points);
    setPart2Finished(true);
    setFinish(true);
  }

  const redirectLevel1 = () => window.location.href = "https://briantracyenglish.pl/dla-ciebie/szybki-angielski";
  const redirectLevel2 = () => window.location.href = "https://briantracyenglish.pl/dla-ciebie";

  const finishTest = () => {
    const level = getLevel();
    sendResults();
    setTimeout(() => {
      if (level === 1) {
        redirectLevel1();
      } else {
        redirectLevel2();
      }
    }, 1000);
  }

  const handleEmailChange = (ev) => {
    const val = ev.target.value;
    setEmail(val);
    setEmailValid(validateEmail(val));
  }

  const startTest = () => {
    setEmailApprove(true);
  }

  const getLevel = () => points >= levelThreshold ? 2 : 1;

  const sendResults = () => {
    return;
    const level = getLevel();
    const formData = new FormData();
    formData.set('name', name);
    formData.set('email', email);
    formData.set('phone', phone);
    formData.set('points', points);
    formData.set('points1', part1Points);
    formData.set('points2', part2Points);
    formData.set('level', level);
    formData.set('sum', 3378);
    axios.post(`${baseUrl}/submit.php`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(res => console.log('success', res))
      .catch(err => console.log('err: ', err));
  }

  const renderIntro = () => {
    return (
      <div className={classes.wrap}>
        <h3>Test poziomujący</h3>
        {/* <Button 
            color="secondary"
            variant="outlined"
            onClick={sendResults}
          >
            Send test
          </Button> */}
        {intro.map((p, idx) => <p key={idx}>{p}</p> )}
        {emailApprove && <div className={classes.introButtons}>
          <Button 
            color="secondary"
            variant="outlined"
            disabled={part1Finished}
            onClick={() => setView('part1')}
          >
            Część I
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            disabled={!part1Finished || part2Finished}
            onClick={() => setView('part2')}
          >
            Część II
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            disabled={!part1Finished}
            onClick={finishTest}
          >
            Zakończ
          </Button>
        </div>}
        {!emailApprove &&  <div className={classes.introButtons}>
          <TextField
            label="Twoje imię*"
            variant="outlined"
            value={name}
            onChange={ev => setName(ev.target.value)}
            className={classes.text}
          />
          <TextField
            label="Adres email*"
            variant="outlined"
            value={email}
            onChange={handleEmailChange}
            className={classes.text}
          />
          <TextField
            label="Numer telefonu"
            variant="outlined"
            value={phone}
            onChange={ev => setPhone(ev.target.value)}
            className={classes.text}
          />
          <Button
            color="secondary"
            variant="outlined"
            disabled={!emailValid || !name}
            onClick={startTest}
          >
            Rozpocznij test
          </Button>
        </div>}
        {!emailApprove &&  <p><small>* Pola oznaczone gwiazdką są obowiązkowe.</small></p>}
      </div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.pageWrap}>
        <Paper className={classes.container}>
          {view === 'intro' && renderIntro()}
          {view === 'part1' && <Test data={data1} finish={finishPart1} />}
          {view === 'part2' && <Test data={data2} finish={finishPart2} />} 
        </Paper>
      </div>
    </ThemeProvider>
  );
}

export default App;
